/**
 * Helpers para determinar las capacidades de una organización a partir
 * del usuario con sesión activa. Las fuentes son:
 *  - hierarchyType: 'ONE_LEVEL' | 'TWO_LEVELS' en el modelo User.
 *  - allowSubmembers: boolean en el modelo User (default true).
 */

export function hasChapters(user) {
  return user?.hierarchyType === 'TWO_LEVELS';
}

export function hasOneLevelStructure(user) {
  return user?.hierarchyType === 'ONE_LEVEL';
}

export function allowsSubmembers(user) {
  if (!user) return false;
  if (user.allowSubmembers === false) return false;
  return true;
}

export function getOrganizationOwner(user) {
  if (!user) return null;
  if (user.role === 'HEAD_OFFICE' || user.role === 'ORGANIZATION' || user.role === 'ONE_LEVEL_HEAD_OFFICE') {
    return user;
  }
  return user.headOffice && typeof user.headOffice === 'object' ? user.headOffice : null;
}

export function orgHasChapters(user) {
  const owner = getOrganizationOwner(user);
  return hasChapters(owner || user);
}

export function orgAllowsSubmembers(user) {
  const owner = getOrganizationOwner(user);
  return allowsSubmembers(owner || user);
}
